import React, {
  ComponentType,
  useEffect,
  useState
} from 'react'
import {
  Dropdown,
  Responsive
} from 'semantic-ui-react'
// Local
import {
  API_URL,
  PATIENT_PROPERTY
} from '../../constant'
import { api } from '../../action/api'

const SafeResponsive = Responsive as unknown as ComponentType<any>
const SafeDropdown = Dropdown as unknown as ComponentType<any>

type DropdownOption = {
  key: string
  value: string
  text: string
}

type VbcProgramSelectProps = {
  onChange?: (
    event: React.SyntheticEvent,
    data: {
      name: string
      value: string | null
    }
  ) => void
  name?: string
  value?: string
  placeholder?: string
  allOption?: boolean
}

/**
 * Provides a stand-alone patient VBC / quality program select widget
 *
 * @param onChange Callback function to execute when a program is selected
 *   arguments: (e, {name, value}) where value is the program name or "" if
 *   the ALL option is selected
 * @param name Name of the program select widget in a form context
 * @param value Initial selected program
 * @param placeholder Placeholder text. Default: VBC Programs
 * @param allOption If true, include an 'ALL' option. Default: true
 */
function VbcProgramSelect(props: VbcProgramSelectProps): JSX.Element {
  const {
    onChange: onChangeProp,
    name: nameProp,
    value: valueProp,
    placeholder: placeholderProp,
    allOption: hasAllOptionProp
  } = props

  const [
    programs,
    setPrograms
  ] = useState<string[]>([])
  const hasAllOption = hasAllOptionProp !== false

  useEffect(() => {
    let mounted = true
    api.get(API_URL.PATIENT_PROPERTY_VALUES(PATIENT_PROPERTY.QUALITY_PROGRAM), {}).then(({ data }: { data: string[] }) => {
      if (!mounted) return
      setPrograms(data)
    })
    return () => { mounted = false }
  }, [])

  const handleChange = (
    event: React.SyntheticEvent,
    data: {
      value: string
    }
  ) => {
    if (onChangeProp) {
      const name = nameProp || 'vbcProgram'
      const val = data.value === 'ALL'
        ? null
        : data.value
      onChangeProp(
        event,
        {
          name,
          value: val
        }
      )
    }
  }

  const baseOptions: DropdownOption[] = programs.map(name => ({
    key: name,
    value: name,
    text: name
  }))

  const options = hasAllOption === true
    ? [
      {
        key: 'ALL',
        text: 'All',
        value: 'ALL'
      },
      ...baseOptions
    ]
    : baseOptions

  const placeholder = placeholderProp || 'VBC Programs'
  const value = valueProp || undefined

  return (
    <SafeResponsive
      as={ SafeDropdown }
      selection
      placeholder={ placeholder }
      onChange={ handleChange }
      options={ options }
      value={ value }
    />
  )
}

export default VbcProgramSelect
